import { render, staticRenderFns } from "./OrganisationSettings.vue?vue&type=template&id=4f525cc0&scoped=true"
import script from "./OrganisationSettings.vue?vue&type=script&lang=js"
export * from "./OrganisationSettings.vue?vue&type=script&lang=js"
import style0 from "./OrganisationSettings.vue?vue&type=style&index=0&id=4f525cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f525cc0",
  null
  
)

export default component.exports